import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class AtomsFormsClickableInputComponent extends Component {
  @tracked isEditMode = false;
  @tracked hasErrors = false;

  @action
  toggleEditMode() {
    if (this.args.disabled) this.isEditMode = false;
    else this.isEditMode = !this.isEditMode;
  }

  @action
  async saveForm(changeset, e) {
    e?.preventDefault?.();
    await changeset.validate();
    if (!changeset.get('isValid')) {
      this.hasErrors = true;
      return;
    } else {
      this.hasErrors = false;
    }
    changeset
      .save()
      .then(() => {
        this.args?.afterSave?.();
      })
      .catch((err) => {
        console.debug(err);
        changeset.rollback();
      });
    this.toggleEditMode();
  }

  @action
  cancelForm(changeset) {
    changeset.rollback();
    this.isEditMode = false;
  }

  @action
  handleInputChange(changeset, field, event) {
    changeset.set(field, event.target.value);
  }
}
